import { Vector2 } from '@babylonjs/core';

import { DoubleTouchBase, RotationOption, TouchData } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { checkXAxisDoubleTouch, getMultiTouchPanPosition, rotateByPanning } from '../ZEDCameraInputHelper';
import { InputCanvasProps } from '../ZEDCameraInputManager';

let prevPanPosition: Vector2 = Vector2.Zero();
export const DoubleTouchXAxisRotationAll: DoubleTouchBase & RotationOption = {
  type: 'DoubleTouch',
  touchCount: 2,
  key: 'DoubleTouchXAxis',
  name: 'DoubleTouchXAxisRotationAll',
  option: {
    alpha: true,
    beta: true,
    inertia: 0,
    sensibilityX: 100,
    sensibilityY: 100,
  },
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  checkCondition(_camera: ZEDCamera, touchData: TouchData[]) {
    prevPanPosition = getMultiTouchPanPosition(touchData);
    return checkXAxisDoubleTouch(touchData, 0.8);
  },
  onTouchStart(camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {
    camera.stopPlayingAnimation();
  },
  onTouchMoved(camera, touchData, _canvasProps) {
    if (touchData[1]) {
      rotateByPanning(
        camera,
        touchData[1].movement,
        DoubleTouchXAxisRotationAll.option.inertia,
        DoubleTouchXAxisRotationAll.option.sensibilityX,
        DoubleTouchXAxisRotationAll.option.sensibilityY
      );
    }
  },
  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {
    prevPanPosition = Vector2.Zero();
  },
};
